module.exports = __webpack_public_path__ + "static/media/img_text_highlights.4eb5c5e8.png";